<div
  class="ventilation-settings-tile flex flex-col gap-[24px] flex-[1_0_100%]"
  feature
  *ngIf="ventilationQuickSelectionsView$ | async as quickSelections"
>
  <div class="flex flex-row justify-between items-center">
    <h3>{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.QUICK_SELECTIONS.TITLE' | translate }}</h3>

    <p class="{{ quickSelections.isActive === false ? 'disabled' : '' }}">
      {{ '+INSTALLATIONS.INSTALLATION.VENTILATION.QUICK_SELECTIONS.REMAINING_TIME' | translate }}:
      {{ quickSelections.isActive ? (quickSelections.remainingTime | minutesOrHours) : NO_VALUE }}
    </p>
  </div>

  <mat-radio-group
    class="flex flex-col gap-[8px]"
    [ngModel]="quickSelectionCheckedProgram"
    (ngModelChange)="onVentilationQuickSelectionProgramChange($event)"
  >
    <vi-radio-button
      [value]="FeatureNames.ventilationQuickmodesSilent"
      [label]="customTranslationsService.VENTILATION_PROGRAMS.silent | translate"
      [checked]="quickSelectionCheckedProgram === FeatureNames.ventilationQuickmodesSilent"
      [disabled]="quickSelections.isActive"
      data-at-quick-selection="silent"
      [attr.data-at-disabled]="quickSelections.isActive"
    >
    </vi-radio-button>

    <vi-radio-button
      [value]="FeatureNames.ventilationQuickmodesForcedLevelFour"
      [label]="customTranslationsService.VENTILATION_PROGRAMS.intensive | translate"
      [checked]="quickSelectionCheckedProgram === FeatureNames.ventilationQuickmodesForcedLevelFour"
      [disabled]="quickSelections.isActive"
      data-at-quick-selection="intensive"
      [attr.data-at-disabled]="quickSelections.isActive"
    >
    </vi-radio-button>

    <vi-radio-button
      [value]="FeatureNames.ventilationQuickmodesTemporaryShutdown"
      [label]="customTranslationsService.VENTILATION_PROGRAMS.temporaryShutdown | translate"
      [checked]="
        quickSelectionCheckedProgram === FeatureNames.ventilationQuickmodesTemporaryShutdown
      "
      [disabled]="quickSelections.isActive"
      data-at-quick-selection="temporaryShutdown"
      [attr.data-at-disabled]="quickSelections.isActive"
    >
    </vi-radio-button>
  </mat-radio-group>

  <div class="quick-selections-wrapper items-center">
    <div>
      <mat-form-field mat-select-height-large>
        <mat-label>{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.QUICK_SELECTIONS.HOURS' | translate
        }}</mat-label>
        <mat-select
          (selectionChange)="onVentilationQuickSelectionHoursChange($event)"
          [(ngModel)]="ventilationTimeoutHours"
          data-at-quick-selection-dropdown="hours"
          [disabled]="quickSelections.isActive"
          [attr.data-at-disabled]="quickSelections.isActive"
          fieldTextContentTooltip
        >
          <mat-option
            [disabled]="ventilationTimeoutMinutes === VENTILATION_ZERO_VALUE"
            [value]="VENTILATION_ZERO_VALUE"
            fieldTextContentTooltip
            >{{ VENTILATION_ZERO_VALUE }}</mat-option
          >
          <mat-option *ngFor="let hour of hours" [value]="hour" fieldTextContentTooltip>{{
            hour
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      &nbsp;&nbsp;
      <mat-form-field mat-select-height-large>
        <mat-label>{{
          '+INSTALLATIONS.INSTALLATION.VENTILATION.QUICK_SELECTIONS.MINUTES' | translate
        }}</mat-label>
        <mat-select
          [(ngModel)]="ventilationTimeoutMinutes"
          [disabled]="quickSelections.isActive || ventilationTimeoutHours === VENTILATION_MAX_HOURS"
          data-at-quick-selection-dropdown="minutes"
          [attr.data-at-disabled]="quickSelections.isActive"
          fieldTextContentTooltip
        >
          <mat-option
            [disabled]="ventilationTimeoutHours === VENTILATION_ZERO_VALUE"
            [value]="VENTILATION_ZERO_VALUE"
            fieldTextContentTooltip
            >{{ VENTILATION_ZERO_VALUE }}</mat-option
          >
          <mat-option *ngFor="let minute of minutes" [value]="minute" fieldTextContentTooltip>{{
            minute
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button
        mat-button
        mat-stroked-button
        class="ventilation-quick-selection-btn flex-[1_1_100%]"
        [attr.data-at-quick-selection-button]="quickSelections.isActive ? 'stop' : 'start'"
        (click)="doQuickSelectionAction()"
      >
        {{
          quickSelections.isActive === false
            ? ('+INSTALLATIONS.INSTALLATION.VENTILATION.QUICK_SELECTIONS.START_VENTILATION'
              | translate)
            : ('+INSTALLATIONS.INSTALLATION.VENTILATION.QUICK_SELECTIONS.STOP_VENTILATION'
              | translate)
        }}
      </button>
    </div>
  </div>
</div>
